import React from 'react';
import {Accordion, Card} from "react-bootstrap";
import BillingAddressAdd from "./BillingAddressAdd";
import BillingAddressChange from "./BillingAddressChange";
import {useFieldArray} from "react-hook-form";

const BillingAddressTab = (props) => {
    const {fields} = useFieldArray({name: "addedBillingAddresses"});
    const {fields: changedFields} = useFieldArray({name: "changedBillingAddresses"});
    return (
        <Card>
            <Card.Body className={"bg-light"}>
                {fields && fields.length > 0 && 
                    <Accordion defaultActiveKey={fields.some(s => s.status === "Undecided") ? fields.findIndex(s => s.status === "Undecided").toString() : "0"} className={"mb-4"}>
                        {fields.map((field, index) => (
                            <BillingAddressAdd billingAddressIndex={index}
                                               billingAddressAdded={field}
                                               key={field.id}
                            />
                        ))}
                    </Accordion>
                }
                {changedFields && changedFields.length > 0 && 
                    <Accordion defaultActiveKey={fields.some(s => s.status === "Undecided") ? changedFields.findIndex(s => s.status === "Undecided").toString() : "0"} className={"mb-4"}>
                        {changedFields.map((field, index) => {
                            return <BillingAddressChange billingAddressChanged={field}
                                                         billingAddressIndex={index}
                                                         key={field.id}
                            />
                        })}
                    </Accordion>
                }
            </Card.Body>
        </Card>
    )
}
export default BillingAddressTab